import HomepageSidebar from "../pages/homepage/HomepageSidebar";
import {Outlet, useLocation} from "react-router-dom";

const HomepageFrame = () => {

    const location = useLocation();


    return (
        <div className="bg-black d-flex">
            <HomepageSidebar defaultActiveKey={location.pathname.split("/")[1]} />
            <Outlet />
        </div>
    );
}

export default HomepageFrame;